import React, { useState, useEffect } from 'react'
import { Pagination } from 'antd';
import { Link } from 'react-router-dom';


function ContactViewedListContainer({ matches, title }) {
  const [list, setList] = useState(matches);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10; // Number of items to show per page

  useEffect(() => {
    setList(matches);
    setCurrentPage(1);
  }, [matches]);
  if (!matches || !matches.length) return (
    <h5 className="pageHeading text-center">No Results Found</h5>
  )

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const lastIndex = currentPage * pageSize;
  const firstIndex = lastIndex - pageSize;
  const paginatedList = list.slice(firstIndex, lastIndex);


  return (
    <>
      <h5 className="pageHeading text-center">{title} </h5>
      {paginatedList.map((match, index) => (
        <div className="main-card-contact" key={index}>
          <div>
            You viewed <span>{match.data.firstName} {match.data.lastName}'s </span> contact details <span>{match.data.email === "" ? "Email Hidden" : match.data.email} / {match.data.mobile === "" ? "Mobile Phone Hidden" : match.data.mobile}</span>
          </div>
          <Link to={`/view-profile/${match.userId}`}>
            View {match.data.userId}'s Profile
          </Link>
        </div>
      ))}
      <div className="paginator d-flex justify-content-center">
        <Pagination
          current={currentPage}
          total={list.length}
          pageSize={pageSize}
          onChange={handlePageChange}
          className="pagination"
        />
      </div>
    </>
  )
}

export default ContactViewedListContainer